import React from "react"
import { useSelector } from "react-redux"

import { Button } from "../../../../components/DesignSystem"

import PaymentCard from "../../../../components/PaymentCard"
import SectionHeader from "../SectionHeader"

import "./index.scss"

function PaymentConfirmation({ handleChangeStep }) {
  const { payment, previousStep } = useSelector(
    (state) => state.charge,
  )
  let oneLumpSum = 0
  if(payment.paymentType !== 'credit') {
    oneLumpSum = Number(payment.total)
  }

  let totalWithFees = 0
  if(payment.paymentType === 'credit') {
    totalWithFees = payment.numberInstallments * payment.valueInstallments
  }

  function handleGoBack() {
    if (previousStep === 2) {
      handleChangeStep(2)
      return
    }
    handleChangeStep(1)
  }

  function handleSubmit() {
    // if (debtInfo.status === "NEGOTIATION") {
    //   handleChangeStep(9)
    //   return
    // }
    handleChangeStep(4)
  }

  return (
    <div className="payment-confirmation">
      <SectionHeader handleGoBack={handleGoBack}>
        <h2>Confirme sua escolha</h2>
      </SectionHeader>
      <section>
        {payment.paymentType === "credit" ? (
          <PaymentCard
            type="selected"
            typePayment="Parcelado"
            way="Boleto bancário"
            total={totalWithFees}
            entry = {0}
            numberInstallments={payment.numberInstallments}
            valueInstallments={payment.valueInstallments}
            withButton={false}
            minHeight="150px"
          />
        ) : (
          <PaymentCard
            type="selected"
            typePayment="À vista"
            way="Boleto bancário"
            interestRate={payment.interestRate}
            total={oneLumpSum}
            withButton={false}
            minHeight="150px"
          />
        )}
        <Button
          size="small"
          contained
          type="submit"
          icon="ArrowRight"
          iconRight
          sizeIcon={16}
          onClick={handleSubmit}
        >
          Continuar
        </Button>
      </section>
    </div>
  )
}

export default PaymentConfirmation
